import React, { useState } from 'react';
import RegistrationList from './RegistrationList';
import CustomerList from './CustomerList';
import WarrantyRequestList from './WarrantyRequestList';
import { useNavigate } from 'react-router-dom';


import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  CssBaseline,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Divider,
  Button,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const drawerWidth = 240;

export default function Dashboard() {
  const [active, setActive] = useState('registrations');
  const [open, setOpen] = useState(true);
  const nav = useNavigate();

  function logout() {
    localStorage.removeItem('token');
    nav('/login');
  }

  const menuItems = [
    { id: 'registrations', label: 'نمایش درخواست‌های رجیستری' },
    { id: 'customers', label: 'مشتریان با گارانتی فعال' },
    { id: 'requests', label: 'مشاهده درخواست‌های گارانتی' },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row-reverse', direction: 'rtl' }}>
      <CssBaseline />

      {/* ✅ Full-width AppBar */}
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: '#1976d2',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {/* Right side (menu toggle + title) */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              color="inherit"
              onClick={() => setOpen(!open)}
              sx={{ ml: 1 }}
            >
              {open ? <ChevronRightIcon /> : <MenuIcon />}
            </IconButton>
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                داشبورد مدیریت
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                صنایع برودتی میلاد
              </Typography>
            </Box>
          </Box>

          {/* Left side (logout button) */}
          <Button
            color="inherit"
            startIcon={<LogoutIcon />}
            onClick={logout}
            sx={{
              fontWeight: 'bold',
              border: '1px solid rgba(255,255,255,0.4)',
              borderRadius: '8px',
              px: 2,
            }}
          > خروج  
          </Button>
        </Toolbar>
      </AppBar>

      {/* ✅ Sidebar Drawer on right */}
      <Drawer
        variant="persistent"
        anchor="right"
        open={open}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: '#f9f9f9',
            borderLeft: '1px solid #ddd',
            transition: 'all 0.3s ease',
          },
        }}
      >
        <Toolbar />
        <Box sx={{ textAlign: 'center', p: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
            منو
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Typography variant="subtitle2" sx={{ color: '#555', mb: 1 }}>
            مدیریت خریداران
          </Typography>
        </Box>

        <List>
          {menuItems.map((item) => (
            <ListItem key={item.id} disablePadding>
              <ListItemButton
                onClick={() => setActive(item.id)}
                selected={active === item.id}
                sx={{
                  textAlign: 'right',
                  transition: '0.2s',
                  '&.Mui-selected': {
                    backgroundColor: '#1976d2',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#1565c0',
                    },
                  },
                  '&:hover': {
                    backgroundColor: '#e3f2fd',
                  },
                }}
              >
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Divider sx={{ my: 2 }} />
        <Box sx={{ textAlign: 'center', pb: 2 }}>
          <Typography variant="subtitle2" sx={{ color: '#888' }}>
            گزارش‌ها
          </Typography>
          <ListItemButton sx={{ textAlign: 'right', '&:hover': { backgroundColor: '#e3f2fd' } }}>
            <ListItemText primary="غیرفعال" />
          </ListItemButton>
        </Box>
      </Drawer>

      {/* ✅ Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: 8,
          backgroundColor: '#f5f6fa',
          minHeight: '100vh',
          transition: 'margin-right 0.3s ease',
          // ⬅ Push content left when drawer open
          mr: open ? `${drawerWidth}px` : '0px',
        }}
      >
        {active === 'registrations' && <RegistrationList />}
        {active === 'customers' && <CustomerList />}
        {active === 'requests' && <WarrantyRequestList />}
      </Box>
    </Box>
  );
}
